var map = {
	"./blackstar/1.mp4": 39816,
	"./blackstar/2.mp4": 82562,
	"./blackstar/3.mp4": 99221,
	"./blackstar/bs.mp4": 68869,
	"./bscafe/1.mp4": 75591,
	"./bscafe/2.mp4": 72215,
	"./bscafe/3.mp4": 25469,
	"./bscafe/bscafe.mp4": 50010,
	"./centris/1.mp4": 14656,
	"./centris/2.mp4": 21995,
	"./centris/3.mp4": 20476,
	"./centris/fit.mp4": 37521,
	"./kanstik/1.mp4": 81575,
	"./kanstik/2.mp4": 65772,
	"./kanstik/3.mp4": 78561,
	"./kanstik/kanstik.mp4": 16440,
	"./main-mob.mp4": 96978,
	"./main.mp4": 23266,
	"./pit/1.mp4": 9685,
	"./pit/2.mp4": 91501,
	"./pit/3.mp4": 83029,
	"./pit/pit.mp4": 85646,
	"./print/1.mp4": 39459,
	"./print/2.mp4": 57699,
	"./print/3.mp4": 92399,
	"./print/print.mp4": 83389,
	"./tibbiyot/1.mp4": 52483,
	"./tibbiyot/2.mp4": 42754,
	"./tibbiyot/3.mp4": 72824,
	"./tibbiyot/tibiyot.mp4": 34104,
	"./webDevelopment/WebDev_main_video.mp4": 31762,
	"./webDevelopment/akfa-mob.mp4": 54782,
	"./webDevelopment/akfa.mp4": 64866,
	"./webDevelopment/akfa__room.mp4": 48950,
	"./webDevelopment/cardinar-mob.mp4": 62021,
	"./webDevelopment/cardinar.mp4": 58475,
	"./webDevelopment/cardinar__seat.mp4": 57804,
	"./webDevelopment/maxdecor-mob.mp4": 63786,
	"./webDevelopment/maxdecor.mp4": 18387,
	"./webDevelopment/puzzle-mob.mp4": 24467,
	"./webDevelopment/puzzle.mp4": 26246,
	"./webDevelopment/shtarsystem-mob.mp4": 25378,
	"./webDevelopment/shtarsystem.mp4": 74486,
	"./webDevelopment/ytong-mob.mp4": 28278,
	"./webDevelopment/ytong.mp4": 16997,
	"./webDevelopment/ytong__block.mp4": 8395,
	"./wella/1.mp4": 28707,
	"./wella/2.mp4": 51711,
	"./wella/3.mp4": 85764,
	"./wella/wella.mp4": 62175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61366;